import React from 'react';
import moment from 'moment';

class LogEntriesList extends React.Component {
    render() {

        const { log_entries = [], search = '' } = this.props;
        const filteredEntries = (log_entries || []).filter(entry =>
            `${entry.FirstName} ${entry.LastName}`.toLowerCase().includes(search.toLowerCase()) ||
            entry.human.toLowerCase().includes(search.toLowerCase())
        );

        return <section>
            <table className="w-100 table m-0 poppins bg-gray-2 white font-10">
                <thead>
                    <tr>
                        <th className="bg-gray-2 white">#</th>
                        <th className="bg-gray-2 white">Timestamp</th>
                        <th className="bg-gray-2 white">User | Staff</th>
                        <th className="bg-gray-2 white">Message</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredEntries && filteredEntries.map((entry, index) => (
                        <tr key={index} >
                            <td className="bg-gray-2 white">{index + 1}</td>
                            <td className="bg-gray-2 white">{moment(entry.created_at).format('MMM Do YYYY @ hh:mmA')}</td>
                            <td className="bg-gray-2 white">{`${entry.FirstName} ${entry.LastName}`}</td>
                            <td className="bg-gray-2 white">{entry.human}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </section>
    }
}

export default LogEntriesList;